@if (order) {
  <div class="order-summary--totals">
    <div class="order-summary--totals__header">
      <h2 class="m-0">
        {{ title }} ({{ order.items.length }}
        {{ order.items.length === 1 ? ' item' : ' items' }})
      </h2>
    </div>
    <div class="order-summary--totals__body">
      <div class="my-3">
        <span class="uppercase font-4">Subtotal</span>
        <span id="order-summary-subtotal" class="price fw-normal font-2">{{
          order.subTotal | currency
        }}</span>
      </div>
      <div class="my-3">
        <span class="uppercase font-4"
          >Shipping&nbsp;<i
            class="fal fa-info-circle"
            ngbTooltip="{{ shippingInfo }}"
            placement="{{ tooltipPosition }}"
            tooltipClass="tooltips"
          ></i
        ></span>
        <span id="order-summary-shipping" class="price fw-normal font-2">{{
          order.shippingTotal | currency
        }}</span>
      </div>
      <div
        class="mt-3 pb-2"
        [ngClass]="{ 'color-red': taxExemptOrderHasTaxes }"
      >
        <span class="uppercase font-4"
          >Taxes&nbsp;
          @if (taxExemptOrderHasTaxes) {
            <i
              class="fal fa-info-circle"
              ngbTooltip="{{ taxExemptInfo }}"
              placement="{{ tooltipPosition }}"
              tooltipClass="tooltips"
            ></i>
          }
        </span>
        <span id="order-summary-tax" class="price fw-normal font-2">{{
          order.taxes | currency
        }}</span>
      </div>
      @if (order.discountTotal > 0 || order.budgetTotal > 0) {
        <div class="mt-3 line-separator--grey"></div>
        @if (order.discountTotal > 0) {
          <div class="my-3">
            <span class="uppercase font-4">Discounts</span>
            <span
              id="order-summary-discount"
              class="price green fw-normal font-2"
              >-{{ order.discountTotal | currency }}</span
            >
          </div>
        }
        @if (order.budgetTotal > 0) {
          <div class="my-3">
            <a
              href="#"
              class="link link-underline uppercase font-4 fw-normal"
              (click)="showBudgetDetails()"
              >Budget Applied&nbsp;<i class="fas fa-exclamation-circle"></i
            ></a>
            &nbsp;<span
              id="order-summary-budget"
              class="price green fw-normal font-2"
              >-{{ order.budgetTotal | currency }}</span
            >
          </div>
        }
      }
      <div class="flex-1-1"></div>
      <div class="line-separator--grey"></div>
      <div class="my-3">
        <span class="uppercase font-4 fw-bold">Total</span>
        <span id="order-summary-total" class="price font-1">{{
          order.totalCost | currency
        }}</span>
      </div>
    </div>
  </div>
}
